import React from "react"
import DsaRoll from "../components/DsaRoll"
import blogImg from "../img/blog-img-19.png"
import { Link } from "gatsby"
import NavigationBar from "../components/Navbar"
import Footer from "../components/footer"
import NewsletterStrip from "../components/newsletterStrip"
import { Helmet } from "react-helmet"

export default class BlogDsaIndexPage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>DSA</title>
          <meta name="description" content="DSA Page" />
        </Helmet>
        <NavigationBar />
        <div className="max-w-screen-xl px-4 mx-auto mt-5 mb-4 lg:mb-2 sm:mt-12 sm:px-6 md:mt-20 xl:mt-24">
          <div className="-mt-6 lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
              <h2 className="mb-6 -mt-2 text-3xl font-bold leading-10 tracking-tight text-gray-900 md:text-4xl sm:leading-none">
                Why Our <span className="">Blogs?</span>
                <br className="" />
              </h2>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                We design career-focused content with a guided structure and
                help programmers to develop a long-term interest in
                problem-solving. Enjoy learning, Enjoy thinking!
              </p>
              <div className="mt-5 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0"></div>
            </div>
            <div className="relative mt-2 sm:max-w-lg sm:mx-auto lg:-mt-14 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
              <div className="relative w-full mx-auto rounded-lg lg:max-w-md">
                <button className="relative block w-full overflow-hidden rounded-lg focus:outline-none focus:shadow-outline">
                  <img
                    className="w-full"
                    src={blogImg}
                    alt="Woman making a sale"
                  />
                  <div className="absolute inset-0 flex items-center justify-center w-full h-full"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="sm:block overflow-x">
          <div className="border-b border-gray-200 overflow-x">
            <nav className="flex overflow-x">
              <Link
                to="/blog/"
                className="flex-1 px-1 py-3 text-sm font-medium leading-5 text-center text-gray-500 border-b-2 lg:py-4 md:py-4 lg:text-lg md:text-lg overflow-x hover:text-green-500 hover: hover:border-green-500"
              >
                Latest
              </Link>
              <Link
                to="/data-structures-and-algorithms/"
                className="flex-1 px-1 py-3 text-sm font-medium leading-5 text-center text-green-500 border-b-2 border-green-500 lg:py-4 md:py-4 lg:text-lg md:text-lg overflow-x"
              >
                DSA
              </Link>
              <Link
                to="/machine-learning/"
                className="flex-1 px-1 py-3 text-sm font-medium leading-5 text-center text-gray-500 border-b-2 lg:py-4 md:py-4 lg:text-lg md:text-lg overflow-x hover:text-green-500 hover: hover:border-green-500"
              >
                Machine Learning
              </Link>
              <Link
                to="/system-design/"
                className="flex-1 px-1 py-3 text-sm font-medium leading-5 text-center text-gray-500 border-b-2 lg:py-4 md:py-4 lg:text-lg md:text-lg overflow-x hover:text-green-500 hover: hover:border-green-500"
              >
                System Design
              </Link>
              <Link
                to="/critical-ideas/"
                className="flex-1 px-1 py-3 text-sm font-medium leading-5 text-center text-gray-500 border-b-2 lg:py-4 md:py-4 lg:text-lg md:text-lg overflow-x hover:text-green-500 hover: hover:border-green-500 "
              >
                Critical Ideas
              </Link>
            </nav>
          </div>
        </div>
        <section>
          <div className="content">
            <DsaRoll />
          </div>
        </section>

        <NewsletterStrip />
        <Footer />
      </React.Fragment>
    )
  }
}
